import * as React from 'react';
import Component from '../../Component';

export default class Header extends Component {
    render() {
        const t = this.translate();
        return (<h5 className="mb-0">{t('import.employees.form.slack')}</h5>);
    }
}